export default __webpack_public_path__ + "static/media/led_pim2.f3e02a4f.png";